import { StrapiCreate, StrapiUpdate } from '../../types/strapi/strapi'
import { createApi } from '@reduxjs/toolkit/query/react'
import getCustomFetchBase from '../custom-fetch-base'
import Strapi, { EndpointQueryParameters, StrapiSingle } from '../../types/strapi/strapi'
import getQuery from '../../helpers/api/get-query'
import ShipmentPosition from '../../types/api/shipment-position'
import { shipmentsApi } from './shipments-api'

export const shipmentPositionsApi = createApi({
    reducerPath: 'shipmentPositionsApi',
    baseQuery: getCustomFetchBase({ baseUrl: process.env.REACT_APP_API_URL }),
    tagTypes: ['ShipmentPositions'],
    endpoints: builder => ({
        getShipmentPositions: builder.query<
            Strapi<ShipmentPosition>,
            EndpointQueryParameters | void
        >({
            query: getQuery('/shipment-positions'),
            providesTags: ['ShipmentPositions'],
        }),
        getShipmentPositionByDocId: builder.query<
            StrapiSingle<ShipmentPosition>,
            [string, EndpointQueryParameters] | [string]
        >({
            query: ([docId, params]) => getQuery(`/shipment-positions/${docId}`)(params),
        }),
        createShipmentPosition: builder.mutation<
            StrapiSingle<ShipmentPosition>,
            StrapiCreate<ShipmentPosition>
        >({
            query: body => ({
                url: '/shipment-positions',
                method: 'POST',
                body,
            }),
        }),
        updateShipmentPosition: builder.mutation<
            StrapiSingle<ShipmentPosition>,
            StrapiUpdate<ShipmentPosition>
        >({
            query: ({ docId, body }) => ({
                url: `/shipment-positions/${docId}`,
                method: 'PUT',
                body,
            }),
        }),
        deleteShipmentPosition: builder.mutation<void, string>({
            query: docId => ({ url: `/shipment-positions/${docId}`, method: 'DELETE' }),
            // invalidatesTags: ['ShipmentPositions'],
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled
                    dispatch(shipmentsApi.util.invalidateTags(['Shipments']))
                } catch (error) {
                    console.error('Ошибка ревалидации расчетов:', error)
                }
            },
        }),
    }),
})

export const {
    useGetShipmentPositionsQuery,
    useLazyGetShipmentPositionsQuery,
    useLazyGetShipmentPositionByDocIdQuery,
    useCreateShipmentPositionMutation,
    useUpdateShipmentPositionMutation,
    useDeleteShipmentPositionMutation,
} = shipmentPositionsApi
